type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

const TwitterViewIcon = (props: Props) => {
  const {
    width = '18',
    height = '18',
    viewBox = '0 0 24 24',
    fillColor = 'currentColor',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
    >
      <path
        d="M8.75 21V3h2v18h-2zM18 21V8.5h2V21h-2zM4 21l.004-10h2L6 21H4zm9.248 0v-7h2v7h-2z"
        fill={fillColor}
      />
    </svg>
  );
};

export default TwitterViewIcon;
